module.exports = __webpack_public_path__ + "static/tabella-94c86ff722544108e6634b7bfdc86215.svg";